import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const ArrowLeft: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      d="M28.88 14.6632H8.09333L14.7867 7.96995C15.3067 7.44995 15.3067 6.60995 14.7867 6.08995C14.2667 5.56995 13.4267 5.56995 12.9067 6.08995L3 15.9966L12.9067 25.9032C13.1733 26.1699 13.5067 26.2899 13.8533 26.2899C14.2 26.2899 14.5333 26.1566 14.8 25.9032C15.32 25.3832 15.32 24.5432 14.8 24.0232L8.10667 17.3299H28.8933V14.6632H28.88Z"
      fill="currentCOlor"
    />
  </Icon>
);
